<script>
import { storeForms } from '@app/mixins/forms';

export default {
  mixins: [storeForms],
  data() {
    return {
      store: {
        owner_phone: null,
      },
    };
  },
};
</script>

<template>
  <div class="columns">
    <div class="column is-4 content pr-10 is-small">
      <h2 class="is-size-5">
        Numéro de téléphone mobile
      </h2>
      <p>
        Pour mieux vous accompagner, nous avons besoin de
        votre numéro de téléphone avec l’indicatif international.
        Ce numéro ne sera utilisé que pour vous contacter
        en cas de besoin lié à notre support client.
      </p>
    </div>

    <div class="column">
      <form class="box content" @submit.prevent="handle()">
        <p class="has-text-success has-text-weight-bold">
          Veuillez préciser l'indicatif (+33 ou autre).
        </p>
        <b-field label="Téléphone mobile" label-for="owner-phone">
          <b-input
            type="tel"
            id="owner-phone"
            placeholder="+33XXXXXXXXX"
            required
            pattern="^\+(?!0+$)(?![1-9]0+$)\d{7,15}$"
            v-model="store.owner_phone"
          />
        </b-field>

        <div class="buttons is-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading">
            Mettre à jour
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>
